var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SoundNotPlaying } from '@/components/volume-select/sound-not-playing.component';
import { CircularProgress, styled, useTheme, useMediaQuery, } from '@mui/material';
import { useAudioPlayerContext } from 'hx-audio-player';
import { usePreviewLoop } from 'hx-din-test-2';
import { Slider } from 'hx-ui';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BsVolumeOff, BsVolumeUp } from 'react-icons/bs';
export function VolumeSelectContent() {
    var theme = useTheme();
    var state = usePreviewLoop().dinPlayer.state;
    var _a = useFormContext(), getValues = _a.getValues, setValue = _a.setValue;
    var selectedVolume = getValues('volume');
    var setVolume = useAudioPlayerContext().setVolume;
    useEffect(function () {
        if (!selectedVolume) {
            setVolume(0.1);
            return;
        }
        setVolume(selectedVolume / 100);
    }, [selectedVolume]);
    var incrementVolume = function () { return setValue('volume', +selectedVolume + 10); };
    var decrementVolume = function () { return setValue('volume', +selectedVolume - 10); };
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    function formatLabel(value) {
        return "".concat(value / 10);
    }
    return (_jsxs("div", __assign({ className: "flex flex-col md:gap-6 gap-2 justify-center w-full items-center md:px-12 px-6" }, { children: [_jsx(Slider, { orientation: 'horizontal', sx: {
                    border: 'none',
                    width: '100%',
                    height: '7px',
                    '& .MuiSlider-root': {
                        scale: 5,
                    },
                    '& .MuiSlider-track': {
                        border: 'none',
                        height: 7,
                    },
                    '& .MuiSlider-thumb': {
                        background: theme.palette.primary.main,
                    },
                }, step: 10, name: "volume", className: "flex flex-row w-full gap-4", classes: {
                    valueLabel: 'text-norc-orange-dark text-2xl bg-transparent top-0 -right-2 font-medium',
                    rail: 'h-0.5 bg-norc-grey-dark opacity-100',
                    track: 'bg-norc-orange-light',
                }, valueLabelFormat: formatLabel, valueLabelDisplay: isMobile ? 'on' : 'off', BeforeIcon: _jsx(VolumeControl, __assign({ onClick: decrementVolume }, { children: _jsx(BsVolumeOff, { size: "2rem", color: '#EC712E' }) })), AfterIcon: _jsx(VolumeControl, __assign({ onClick: incrementVolume }, { children: _jsx(BsVolumeUp, { size: "2rem", color: '#EC712E' }) })) }), _jsx(SoundNotPlaying, {})] })));
}
var VolumeControl = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});
